export enum EstimationStatus {
  PENDING = "PENDING",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  APPROVED_WITH_CHANGES = "APPROVED_WITH_CHANGES",
  REJECTED = "REJECTED",
  MODIFIED = "MODIFIED",
  PURCHASED = "PURCHASED",
  DELAYED = "DELAYED",
  MY_ESTIMATIONS = "MY_ESTIMATIONS",
}
